/**
 * Client des Reiters "Dashboard": `GET /api/dashboard/stand` liefert den Zeitpunkt des letzten ERFOLGREICHEN
 * DSV-Abgleichs (`ops_job_run`, Job `dsv-abgleich`, `ok = true`) als ISO-Zeit in UTC, `null` solange es noch keinen gab.
 *
 * Der Aufruf geht ueber `anfrage()` (`./basis.ts`) und traegt damit den Bearer-Token der Sitzung. Die Seite behandelt
 * jede Ablehnung als "DSV-Abgleich unbekannt" und laeuft weiter.
 *
 * Dieses Modul gehoert zum nachgeladenen Dashboard-Chunk und importiert deshalb weder `state/fehlerStapel.ts` noch
 * `api/useDateiDownload.ts` (AGENTS.md, "Rolldown zerlegt das Eintrittsbuendel"). Die Typen sind die woertliche
 * Spiegelung der Backend-Antwort und hier eigenstaendig notiert, wie in den uebrigen `api/*.ts`-Modulen.
 */
import { anfrage } from "./basis.ts";

export interface DashboardStand {
  /** ISO-Zeitpunkt (UTC) des letzten erfolgreichen DSV-Abgleichs; `null`, wenn es noch keinen gab. */
  dsvAbgleich: string | null;
}

export async function dashboardStandLaden(): Promise<DashboardStand> {
  return anfrage<DashboardStand>("/api/dashboard/stand");
}
